import { CuratedTeacher } from "models";
import React from "react";

import { IoBusinessSharp } from "react-icons/io5";
import { FaGraduationCap, FaLocationArrow, FaSchool, FaStar } from "react-icons/fa";
// import { FontAwesomeIcon } from "react-icons/fa";

interface StudentTeacherSecondaryInfoProps {
  /** The alum whose details should be displayed. */
  studentTeacher: CuratedTeacher;
  /** Whether the details should be shown in a row or column. */
  direction?: "row" | "column";
}

/** Reusable component to display secondary information for an alum. */
export function StudentTeacherSecondaryInfo({
  studentTeacher,
  direction,
}: StudentTeacherSecondaryInfoProps): JSX.Element {
  const str = studentTeacher.schoolAddress;
  const copy = str.slice(0);
  // eslint-disable-next-line
  const [first, ...rest] = copy.split(",");
  const remainder = rest.join(",").trim();

  // const districtExists = studentTeacher

  function MajorFocus() {
    return (
      <span>
        <FaStar className="margin-less" size={23} color="grey" />
        Major: {studentTeacher.major.charAt(0).toUpperCase()}
        {studentTeacher.major.slice(1)}
      </span>
    );
  }

  return (
    <div className={`secondary-info d-flex flex-${direction || "row"}`}>
      {studentTeacher.schoolAddress && (
        <span>
          <FaLocationArrow className="margin-less" size={23} color="grey" />
          {remainder}
        </span>
      )}
      {studentTeacher.gradYear && (
        <span>
          <FaGraduationCap className="margin-less" size={23} color="grey" />
          Class of {studentTeacher.gradYear}
        </span>
      )}
      {studentTeacher.major && (
        <span>
          <MajorFocus />
        </span>
      )}
      {studentTeacher.schoolName && (
        <span>
          <FaSchool size={23} className="margin-less" color="grey" />
          Student Teacher at {studentTeacher.schoolName}
        </span>
      )}
      {studentTeacher.district && ( // this is the school district within which the student teacher is teaching
        <span>
          <IoBusinessSharp size={23} color="grey" className="margin-less" />
          District: {studentTeacher.district}
        </span>
      )}
    </div>
  );
}
